"use strict";
/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialPattern = void 0;
const WithWhere_1 = require("../clauses/mixins/sub-clauses/WithWhere");
const mixin_1 = require("../clauses/utils/mixin");
const compile_cypher_if_exists_1 = require("../utils/compile-cypher-if-exists");
const Pattern_1 = require("./Pattern");
const PatternElement_1 = require("./PatternElement");
const labels_to_string_1 = require("./labels-to-string");
/** Partial pattern, cannot be used until connected to a node with {@link to}
 * @group Patterns
 */
let PartialPattern = class PartialPattern extends PatternElement_1.PatternElement {
    constructor(variable, options, previous) {
        super(variable);
        this.type = options.type;
        this.properties = options.properties;
        this.previous = previous;
        this.direction = options.direction ?? "right";
        this.length = options.length;
    }
    to(node, options) {
        return new Pattern_1.NestedPattern(node, options, this);
    }
    /**
     * @internal
     */
    getCypher(env) {
        const prevStr = this.previous.getCypher(env);
        const typeStr = this.getTypeStr(env);
        const relStr = this.variable ? `${this.variable.getCypher(env)}` : "";
        const propertiesStr = this.properties ? this.serializeParameters(this.properties, env) : "";
        const whereStr = (0, compile_cypher_if_exists_1.compileCypherIfExists)(this.whereSubClause, env, { prefix: " " });
        const lengthStr = this.generateLengthStr();
        const leftArrow = this.direction === "left" ? "<-" : "-";
        const rightArrow = this.direction === "right" ? "->" : "-";
        return `${prevStr}${leftArrow}[${relStr}${typeStr}${lengthStr}${whereStr}${propertiesStr}]${rightArrow}`;
    }
    generateLengthStr() {
        if (this.length === undefined)
            return "";
        if (typeof this.length === "number") {
            return `*${this.length}`;
        }
        else if (this.length === "*") {
            return "*";
        }
        else {
            return `*${this.length.min ?? ""}..${this.length.max ?? ""}`;
        }
    }
    getTypeStr(env) {
        if (this.type) {
            return (0, labels_to_string_1.typeToString)(this.type, env);
        }
        return "";
    }
};
exports.PartialPattern = PartialPattern;
exports.PartialPattern = PartialPattern = __decorate([
    (0, mixin_1.mixin)(WithWhere_1.WithWhere)
], PartialPattern);
